module.exports = "/fonts/Roboto-Thin.ttf?0f5cc8c05acb7406a2724545d6f38320";